import React from 'react';
import { getColor } from 'core/utils/Styles';
import StarFull from './StarFull';

const StarNewArrivals = props => (
	<StarFull {...props} fill={getColor("burntSienna")} />
);

export default StarNewArrivals;
